import Button from "@mui/material/Button";
import type { SystemSettingsForm } from "../../../../SystemSettings.hooks";
import {
  type FieldEntry,
  schemaDefaultsToApply,
} from "../../../../SystemSettings.utils";

interface SystemSettingsFooterResetProps {
  form: SystemSettingsForm;
  resetFields: FieldEntry[];
  canReset: boolean;
  isSubmitting: boolean;
}

export default function SystemSettingsFooterReset({
  form,
  resetFields,
  canReset,
  isSubmitting,
}: SystemSettingsFooterResetProps) {
  return (
    <Button
      type="button"
      variant="outlined"
      disabled={!canReset || isSubmitting}
      onClick={() => {
        for (const [key, value] of schemaDefaultsToApply(
          resetFields,
          form.state.values
        )) {
          form.setFieldValue(key, value);
        }
      }}
    >
      Reset to defaults
    </Button>
  );
}
